import React from "react";
import { typography, surfaces, borders, textColors, interactive } from "../../../design-system/tokens";

const STYLE_CLASS_BY_VALUE = {
  solid: "border-solid",
  dashed: "border-dashed",
  dotted: "border-dotted",
};

function getBorderColorClassesAndStyle(borderColor, borderOpacity) {
  const isHex = typeof borderColor === "string" && borderColor.startsWith("#");
  const classes = [];
  const style = {};

  if (isHex) {
    if (borderOpacity !== undefined && borderOpacity !== null) {
      const alpha = Math.max(0, Math.min(100, borderOpacity)) / 100;
      const hex = borderColor.replace("#", "");
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      style.borderColor = `rgba(${r}, ${g}, ${b}, ${alpha})`;
    } else {
      style.borderColor = borderColor;
    }
  } else if (borderColor) {
    classes.push(`border-${borderColor}`);
  }

  return { classes: classes.join(" "), style };
}

// In the editor preview, show a thicker line regardless of chosen border width
function getPreviewTopBorderWidthPx() {
  return 6; // pixels
}

export default function BorderStyleField({
  label,
  help,
  value,
  onChange,
  choices = [],
  allValues = {},
}) {
  const borderColor = allValues?.border_color || "blue-600";
  const borderOpacity = allValues?.border_opacity;
  // We intentionally ignore border_width for the preview thickness
  const topWidthPx = getPreviewTopBorderWidthPx();
  const { classes: colorClass, style: colorStyle } = getBorderColorClassesAndStyle(
    borderColor,
    borderOpacity,
  );

  return (
    <div className="field-wrapper">
      {label && <label className={`block mb-2 ${typography.label} ${textColors.secondary}`}>{label}</label>}
      <div className="flex flex-wrap gap-2">
        {choices.map((opt) => {
          const isSelected = value === opt.value;
          const styleClass = STYLE_CLASS_BY_VALUE[opt.value] || "border-solid";
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => onChange(opt.value)}
              className={`flex flex-col items-center p-3 border rounded-lg transition-all ${
                isSelected
                  ? `${interactive.selectedBg} text-white ${interactive.selectedBorder} shadow-sm`
                  : `${borders.default} ${surfaces.primary} ${textColors.primary} ${surfaces.hover}`
              }`}
              aria-pressed={isSelected}
              title={opt.label}
            >
              <div className="w-28">
                <div
                  className={`w-full border-t ${styleClass} ${isSelected ? "" : colorClass}`}
                  style={{
                    ...(isSelected ? { borderColor: "rgba(255,255,255,0.7)" } : colorStyle),
                    borderTopWidth: topWidthPx,
                  }}
                />
                <div className={`mt-2 text-center ${typography.caption} ${isSelected ? "text-white/90" : textColors.primary}`}>
                  {opt.label}
                </div>
              </div>
            </button>
          );
        })}
      </div>
      {help && <div className={`mt-2 ${typography.caption} ${textColors.tertiary}`}>{help}</div>}
    </div>
  );
}
